export const isToggled = ({ toggled }) => toggled
